import type { FileKindEnum } from "__generated__/MediaListQuery.graphql";

export const getIsVideo = (file: { kind: string }) =>
  file.kind === "vehicleVideoPreview" || file.kind === "vehicleVideoRaw";

// NOTE(jesse): I kind of hate this, but it's the only way to define these kinds in one place for all the GQL fragments
export const photoKinds = {
  VEHICLE_IMAGE: "EO",
  VEHICLE_IMAGE_DNG: "DNG Raw",
  VEHICLE_IR_IMAGE: "Infrared",
  VEHICLE_RADIOMETRIC_IMAGE: "Radiometric JPEG",
} as Record<FileKindEnum, string>;

export const videoKinds = {
  VEHICLE_VIDEO_RAW: "MP4",
  VEHICLE_VIDEO_PREVIEW: "Preview Video",
} as Record<FileKindEnum, string>;

export const isImage = (kind: string) => {
  return ["vehicleImage", "vehicleRadiometricImage", "vehicleIrImage", "vehicleImageDng"].includes(
    kind
  );
};

export const isVideo = (kind: string) => {
  return ["vehicleVideoRaw", "vehicleVideoPreview"].includes(kind);
};

export const otherKinds = {
  RTK_ATTACHMENT_MRK: "RTK MRK file",
  RTK_ATTACHMENT_SBF: "RTK SBF file",
  RTK_ATTACHMENT_RINEX_NAV: "RTK RINEX NAV file",
  RTK_ATTACHMENT_RINEX_OBS: "RTK RINEX OBS file",
  RTK_ATTACHMENT_MRK_SCAN: "RTK MRK Scan file",
  RTK_ATTACHMENT_SBF_SCAN: "RTK SBF Scan file",
  RTK_ATTACHMENT_RINEX_NAV_SCAN: "RTK RINEX NAV Scan file",
  RTK_ATTACHMENT_RINEX_OBS_SCAN: "RTK RINEX OBS Scan file",
} as Record<FileKindEnum, string>;

export const internalFileKinds = {
  ANALYTICS: "Analytics",
  CLOUD_FLIGHT_LOG: "Cloud Flight Log",
  C18_FLIGHT_LOG: "C18 Flight Log",
  C93_FLIGHT_LOG: "C93 Flight Log",
  DEBUG_LOG: "Debug Log",
  VEHICLE_LOG: "Vehicle Log",
  TELEMETRY_LOG_V0: "Telemetry Log V0",
  TELEMETRY_LOG_V1: "Telemetry Log V1",
  TELEMETRY_LOG_V2: "Telemetry Log V2",
  TRUNCATED_FLIGHT_LOG: "Truncated Flight Log",
  QCU_FLIGHT_LOG: "QCU Flight Log",
  DOCK_FLIGHT_LOG: "Dock Flight Log",
  VEHICLE_PROCESS_LOG: "Vehicle Process Log",
  ACCESSORY_PROCESS_LOG: "Accessory Process Log",
  PHONE_FLIGHT_LOG: "Phone Flight Log",
} as Record<FileKindEnum, string>;

export const mediaKinds = { ...photoKinds, ...videoKinds, ...otherKinds };

export const allFileKinds = { ...mediaKinds, ...internalFileKinds };

export const getReleaseStatusTagText = (
  file: { fileUsage: string; isCji: boolean } | null,
  dataLevel: string | undefined
) => {
  if (!file) {
    return "";
  }

  let text = "";
  if (file.fileUsage === "RELEASED_BY_CUSTOMER") {
    text = "Released";
  }
  if (dataLevel === "CJIS" && file.isCji === false) {
    if (text.length > 0) {
      text += ":";
    }
    text += "Non-CJI";
  }
  return text;
};
